import { useState, useEffect, useCallback } from 'react';
import { Button, Typography } from '@mui/material';
import SidebarLayout from '../../layouts/SidebarLayout';
import PatientsDataGrid from './components/PatientsDataGrid/PatientsDataGrid';
import PersonAdd from '@mui/icons-material/PersonAdd';
import { usePatientService } from '../../hooks';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Patient } from '../../../domain/entities';
import { loaderActions } from '../../store/loader';

const Patients = () => {
  const PatientService = usePatientService();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [patients, setPatients] = useState<Patient[]>([]);

  const isLoading = (state: boolean) => {
    dispatch(loaderActions.setLoading(state));
  };

  useEffect(() => {
    isLoading(true);

    PatientService.findWithPagination()
      .then((data) => setPatients(data))
      .catch((e) => console.log(e))
      .finally(() => isLoading(false));
  }, []);

  const deletePatient = useCallback(
    (id?: string) => () => {
      setTimeout(() => {
        setPatients((prevRows) => prevRows.filter((row) => row.id !== id));
      });
    },
    []
  );

  const editPatient = (id?: string) => {
    if (!id) return;
    navigate(`/pacientes/${id}`);
  };

  const createPatient = () => {
    navigate('/pacientes/crear');
  };

  return (
    <SidebarLayout>
      <Typography variant='h4' gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
        Pacientes
        <Typography
          variant='body1'
          display='inline'
          color={'GrayText'}
          marginTop={1}
          marginLeft={2}
        >
          {patients.length} registros
        </Typography>
      </Typography>
      <Button
        variant='contained'
        startIcon={<PersonAdd />}
        sx={{ marginBottom: '12px' }}
        onClick={createPatient}
      >
        Añadir
      </Button>
      <div style={{ height: '60vh' }}>
        <PatientsDataGrid
          patients={patients}
          onPatientDeleted={deletePatient}
          onEditPatient={editPatient}
        />
      </div>
    </SidebarLayout>
  );
};

export default Patients;
